<template>
  <aside class="asideBar">
    <ul class="nav nav-pills nav-pills-top nav-flush flex-column mb-auto text-center" >
      <li v-for="(item,t) of sideBarLinksTop" :key="t">
        
          <router-link v-if="item.notification == 'msg'"
            class="nav-link py-1"
            :to="item.link"
       
            data-bs-placement="right"
            :title="item.title"
            
            >
              <img :src="require(`@/assets/images/icons/${item.imgSrc}`)" class="img-fluid"/>
              <!-- Notification Count start -->
              <div v-if="unreadMessagesCount > 0">
                <span class="pulse"></span>
              </div>
              <!-- Notification Count end -->
          </router-link>



          <router-link  v-else
            class="nav-link py-1"
            :to="item.link"
            
            data-bs-placement="right"
            :title="item.title">
              <img :src="require(`@/assets/images/icons/${item.imgSrc}`)" class="img-fluid"/>
          </router-link>





          
      </li>
    </ul>
    <ul class="nav nav-pills nav-pills-bottom nav-flush flex-column mt-auto text-center">
        <li v-for="(item,b) of sideBarLinksBottom" :key="b">
          <router-link
            v-if="item.link"
            class="nav-link py-1"
            :to="item.link"
           
            data-bs-placement="right"
            :title="item.title">
            <img :src="require(`@/assets/images/icons/${item.imgSrc}`)" class="img-fluid"/>
          </router-link>
          <a v-else-if="item.action" @click="item.action" class="nav-link" href="#">
            <img :src="require(`@/assets/images/icons/${item.imgSrc}`)" class="img-fluid"/>
          </a>
        </li>
    </ul>

    <change-password-modal ref="changePasswordModal" />
  </aside>
</template>
<script>
import { Tooltip } from 'bootstrap'
import ChangePasswordModal from '../../profile/person/ChangePasswordModal'
import ConversationResource from '../../../api/conversationResource'

export default {
  name: 'TheSideBar',
  components: { ChangePasswordModal },
  data () {
    return {
      unreadMessagesCount: 0,
      sideBarLinksTop: [
        { link: '/conversations', imgSrc: 'messages.png', title: 'მესიჯები', notification: 'msg' },
        { link: '/correspondence', imgSrc: 'notepad-pen.png', title: 'განცხადებები' },
        // { link: '#', imgSrc: '1-circle.png', title: 'პრობლემები' },
        { link: '/students', imgSrc: 'student.png', title: 'სტუდენტები'  },
        { link: '/lecturers', imgSrc: 'lecturer.png', title: 'ლექტორები'  },
        { link: '/program-dates', imgSrc: 'program_dates.png', title: 'პროგრამის თარიღები'  },
        // { link: '#', imgSrc: 'vc.png', title: 'ვირტუალური კლასი' },
        { link: '/blog', imgSrc: 'blog.png', title: 'ბლოგი'  },
        // { link: '#', imgSrc: 'camera.png', title: 'კამერის დაჯავშვნა' },
        // { link: '#', imgSrc: 'video.png', title: 'გადაღებები' }
      ],
      sideBarLinksBottom: [
        { action: () => { this.handleSettings() }, imgSrc: 'settings.png', title: 'პარამეტრები' },
        { link: '/logout', imgSrc: 'logout.png', title: 'გამოსვლა' }
      ]
    }
  },
  mounted () {
 
    Array.from(document.querySelectorAll(".nav-link"))
      .forEach(tooltipNode => {
 
        new Tooltip(tooltipNode)

      } )

    this.unreadMessages()
  },

  methods: {
    unreadMessages () {
      const res = new ConversationResource()

      res.unreadMessagesCount()
        .then(resp => {
          this.unreadMessagesCount = resp.data.data.count
        })
    },

    handleSettings () {
      this.$refs.changePasswordModal.open()
    }
  }
}
</script>
